import { UseRecurrenceReturn } from './useRecurrence';

export interface RecurrenceDataResult {
  rrule: string;
  endDate?: string;
}

interface UseRecurrenceDataGenerationProps {
  recurrence: UseRecurrenceReturn;
}

/**
 * Hook to handle recurrence data generation for appointment submission
 */
export const useRecurrenceDataGeneration = ({ recurrence }: UseRecurrenceDataGenerationProps) => {
  const generateRecurrenceData = (): RecurrenceDataResult | null => {
    const recurrenceData = recurrence.generateRRule();

    if (!recurrenceData) {
      return null;
    }

    return {
      rrule: recurrenceData.rrule,
      endDate: recurrenceData.endDate || undefined,
    };
  };

  return {
    generateRecurrenceData,
  };
};
